import React from 'react';
import Icon from '../../../components/AppIcon';

const JobStats = ({ stats, autoApply }) => {
const statItems = [
{
label: 'Total Matches',
value: stats?.totalMatches,
icon: 'Target',
color: 'text-primary bg-primary/10'
},
{
label: 'Applied Today',
value: stats?.appliedToday,
icon: 'Send',
color: 'text-success bg-success/10'
},
{
label: 'Auto-Apply Status',
value: autoApply === true ? 'Active' : 'Disabled' ,
icon: 'Zap',
color: 'text-warning bg-warning/10'
},
{
label: 'Response Rate',
value: `${stats?.responseRate}%`,
icon: 'TrendingUp',
color: 'text-accent bg-accent/10'
}
];

return (
<div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
{statItems?.map((item, index) => (
<div key={index} className="bg-card border border-border rounded-lg p-4">
<div className="flex items-center justify-between mb-2">
<div className={`w-10 h-10 rounded-lg flex items-center justify-center ${item?.color}`}>
<Icon name={item?.icon} size={20} />
</div>
</div>
<div className="space-y-1">
<p className="text-2xl font-bold text-text-primary">{item?.value}</p>
<p className="text-sm text-text-secondary">{item?.label}</p>
</div>
</div>
))}
</div>
);
};

export default JobStats;